import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "./work.module.css";

import { WorkSlider } from "../../components";
import { ArrowIndicator, workVideoLunate, workVideoReem, workVideoVault, workVideoLunateSmall, workVideoReemSmall, workVideoVaultSmall, workVideoVaultMob, workVideoReemMob, workVideoLunateMob, workVideoTabadul, workVideoTabadulMob } from "../../../assets";
import useTextAnimation from "../../hooks/useTextAnimation";
import { motion } from 'framer-motion';
import { useDispatch, useSelector } from "react-redux";
import { fetchOurWorkData } from "../../slice/workSlice";
import { IMAGE_URL } from "../../helpers/api_helper";
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_AR, LANG_EN } from '../../helpers/constant';

gsap.registerPlugin(ScrollTrigger);

const Work = () => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 830);
    const { t, i18n } = useTranslation();

    // Adjust videos for different resolutions
    const images = isSmallScreen
        ? [
            { id: 1, src: workVideoVaultMob, title: "Vault", industry: "Fashion" },
            { id: 2, src: workVideoReemMob, title: "Reem Mall", industry: "Retail" },
            { id: 3, src: workVideoTabadulMob, title: "Tabadul", industry: "Finance" },
            { id: 4, src: workVideoLunateMob, title: "Lunate", industry: "Finance" },
        ]
        : [
            { id: 1, src: workVideoVault, title: "Vault", industry: "Fashion" },
            { id: 2, src: workVideoReem, title: "Reem Mall", industry: "Retail" },
            { id: 3, src: workVideoTabadul, title: "Tabadul", industry: "Finance" },
            { id: 4, src: workVideoLunate, title: "Lunate", industry: "Finance" },
        ];

    const dispatch = useDispatch();
    const { data: workData, loading, error } = useSelector((state) => state.work);

    useEffect(() => {
        dispatch(fetchOurWorkData());
    }, [dispatch]);

    // const workListRefs = useRef([]);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth <= 830);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // useEffect(() => {
    //     if (workData.length > 0) {
    //         const container = document.querySelector(`.${styles.work_imageP}`);
    //         container.style.perspective = "1800px";
    //         workListRefs.current.forEach((ref, index) => {
    //             if (ref) {
    //                 gsap.fromTo(
    //                     ref.querySelector(`.${styles.work_image}`),
    //                     {
    //                         scaleX: 1.2,
    //                         scaleY: 1.2,
    //                         y: 0,
    //                         rotateX: 45,
    //                         filter: "blur(10px)",
    //                         transformOrigin: "bottom bottom",
    //                     },
    //                     {
    //                         scaleX: 1,
    //                         y: Math.PI / 6,
    //                         filter: "blur(0px)",
    //                         rotateX: 0,
    //                         scaleY: 1,
    //                         duration: 1,
    //                         transformOrigin: "center center",
    //                         ease: "power2.out",
    //                         scrollTrigger: {
    //                             trigger: ref,
    //                             start: "top 80%",
    //                             end: "center center",
    //                             scrub: true,
    //                         },
    //                     }
    //                 );
    //             }
    //         });
    //     }

    // }, [isSmallScreen]);

    const navigateTo = useNavigate();

    return (
        <div className={styles.work_listing_main}>


            <div className={styles.works_title_wrapper}>
                <h2 className={styles.workTitle}>{t('homeWork')}</h2>
            </div>

            {/* <WorkSlider imageUrls={workData.map((work) => `http://192.168.1.8:3200/public/uploads/work/${work.image}`)} /> */}

            {/* <WorkSlider imageUrls={workData.map((work) => `${IMAGE_URL}/work/${work.bannerImage}`)} /> */}
            {/* <WorkSlider imageUrls={workData.map((work) => `${IMAGE_URL}/work/${isSmallScreen ? work.bannerImageMob : work.bannerImage}`)} /> */}
            {/* <WorkSlider imageUrls={workData.map((work) => `${IMAGE_URL}/work/${isSmallScreen && work.bannerImageMob ? work.bannerImageMob : work.bannerImage}`)} /> */}

            <WorkSlider
                imageUrls={
                    Array.isArray(workData) && workData.length > 0
                        ? workData.map((work) =>
                            `${IMAGE_URL}/work/${isSmallScreen && work.bannerImageMob ? work.bannerImageMob : work.bannerImage}`
                        )
                        : []
                }
                link={
                    Array.isArray(workData) && workData.length > 0
                        ? workData.map((work) => `/our-work/work-detail/${work._id}`)
                        : []
                }
            />

            {/* <div className={styles.wrapper}>
                <div className={styles.work_inner_main}>
                    {Array.isArray(workData) && workData.length > 0 ? (workData.map(({ _id, image, category, title, titleAr, descriptionAr, mobileImage, description }, index) => (
                        <Link to={`/our-work/work-detail/${_id}`} key={_id} >

                            <div
                                className={`${styles.work_list} ${i18n.language === LANG_AR ? 'arab' : ''}`}
                            >
                                <div className={`${styles.work_content} ${i18n.language === LANG_AR ? 'arab' : ''}`}>
                                    <motion.div
                                        initial="hidden"
                                        whileInView="visible"
                                        viewport={{ once: true }}
                                        variants={{
                                            hidden: { opacity: 0, y: 20 },
                                            visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
                                        }}
                                        className={`${styles.work_name} ${i18n.language === LANG_AR ? 'arabText' : ''}`}
                                    >
                                        <h2>{i18n.language === LANG_EN ? title : titleAr}</h2>
                                        <p>{i18n.language === LANG_EN ? category.category : category.categoryAr}</p>
                                        <p dangerouslySetInnerHTML={{
                                            __html: i18n.language === LANG_EN ? description : descriptionAr
                                        }}></p>


                                    </motion.div>

                                    <div className={styles.work_count}>
                                        <span>{`0${index + 1}`}</span>
                                        <span>
                                            <img src={ArrowIndicator} alt="" />
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.work_imageP}>
                                    <div className={styles.work_image}>
                                        {
                                            isSmallScreen ? mobileImage.endsWith('.mp4') || mobileImage.endsWith('.webm') || mobileImage.endsWith('.ogg') ? (
                                                <video
                                                    src={`${IMAGE_URL}/work/${mobileImage}`}
                                                    autoPlay
                                                    muted
                                                    loop
                                                    playsInline
                                                    className={styles.video}
                                                />
                                            ) : (
                                                <img
                                                    src={`${IMAGE_URL}/work/${mobileImage}`}
                                                    alt={title}
                                                    className={styles.mobileImage}
                                                />
                                            ) : image.endsWith('.mp4') || image.endsWith('.webm') || image.endsWith('.ogg') ? (
                                                <video
                                                    src={`${IMAGE_URL}/work/${image}`}
                                                    autoPlay
                                                    muted
                                                    loop
                                                    playsInline
                                                    className={styles.video}
                                                />
                                            ) : (
                                                <img
                                                    src={`${IMAGE_URL}/work/${image}`}
                                                    alt={title}
                                                    className={styles.image}
                                                />
                                            )
                                        }

                                    </div>
                                </div>

                            </div>
                        </Link>
                    ))
                    ) : (
                        <p>No work data available</p>
                    )
                    }



                </div>



            </div> */}
        </div>








    );
};

export default Work;
